import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import QuickActionButton from '../../components/ui/QuickActionButton';
import PersonalInfoSection from './components/PersonalInfoSection';
import HealthPreferencesSection from './components/HealthPreferencesSection';
import NotificationSettingsSection from './components/NotificationSettingsSection';
import PrivacyDataSection from './components/PrivacyDataSection';
import SecuritySection from './components/SecuritySection';
import ThemeCustomizationSection from './components/ThemeCustomizationSection';

const ProfileSettings = () => {
  return (
    <div className="min-h-screen" style={{ background: '#0A0A0B' }}>
      <Helmet>
        <title>Profile Settings - FormForge</title>
        <meta name="description" content="Manage your FormForge account settings, health preferences, privacy options, and security settings." />
      </Helmet>

      <Header />
      
      <main className="container mx-auto px-4 py-8 max-w-6xl">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Inter Tight', sans-serif", color: '#E8EAED' }}>Profile Settings</h1>
          <p style={{ color: '#6B7280' }}>Customize your FormForge experience and manage your account preferences</p>
        </div>

        <div className="space-y-8">
          <PersonalInfoSection />
          <HealthPreferencesSection />
          <NotificationSettingsSection />
          <ThemeCustomizationSection />
          <PrivacyDataSection />
          <SecuritySection />
        </div>

        <div className="mt-12 p-6 rounded-xl text-center" style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.07)' }}>
          <p className="text-sm" style={{ color: '#6B7280' }}>
            Need help with your settings? Visit our{' '}
            <a href="#" style={{ color: '#FF6B00' }} className="hover:underline">Help Center</a>{' '}
            or{' '}
            <a href="#" style={{ color: '#00D4FF' }} className="hover:underline">Contact Support</a>
          </p>
        </div>
      </main>

      <QuickActionButton />
    </div>
  );
};

export default ProfileSettings;